import { render, staticRenderFns } from "./RawColumn.vue?vue&type=template&id=fc287546&scoped=true"
import script from "./RawColumn.vue?vue&type=script&lang=js"
export * from "./RawColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc287546",
  null
  
)

export default component.exports